export default __webpack_public_path__ + "static/travelbookBannerMobile-19123dcaa217d0ef1e7fc496056676be.jpg";